export default __webpack_public_path__ + "static/media/food.2514f837.jpg";